import { styles as commonStyles } from '../../../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../../assets/text-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${widgetSharedStyles}`),
  unsafeCSS(`${colorHelpersStyles}`),
  unsafeCSS(`${flexboxHelpersStyles}`),
  unsafeCSS(`${styleHelpers}`),
  unsafeCSS(`${textHelpersStyles}`),
  unsafeCSS(`${commonStyles}`),
];
